export default import.meta.ROLLUP_FILE_URL_nJkgIVJgL11RgZiGUBj6wA;